import Axios from "axios";
import React, {  useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/Api";
import AlertErrorForm from "./AlertErrorForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import UserDropDown from "./UserDropDown";
import { checkRole } from "../model";


export default function MemberOfParts(props) {
    const { id, onRefresh } = props;
    const { user } = useSelector((state) => state.auth);
    const school_id = user && user.data && user.data.school_id>0?user.data.school_id:0;
    const [refresh, setRefresh] = useState(false);
    const [show, setShow] = useState(false);
    const [members, setMembers] = useState([]);
    const allowReset = checkRole(user,'list-users','reset');

    const formik = useFormik({
        initialValues: {user_id:'',school_id, parts_id:id , ismain:0 },
        enableReinitialize:true,
        validationSchema: Yup.object().shape({
            user_id: Yup.string().required('Chọn tài khoản')
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            Axios.post(URL_LIST_ALL+'users_parts',values, user.config).then((res)=>{
                setSubmitting(false)
                if(res.data.status==='success'){
                    setRefresh(!refresh)
                }else{
                    alert(res.data.message); 
                }
              }).catch((err)=>{
                alert(err); 
              })
        }
    });

    useEffect(() => {
        if(show===true)
        {
            setMembers([])
            Axios.get(URL_LIST_ALL+'users_parts?limit=100&parts_id='+id, user.config).then((res)=>{
                if(res.data.status==='success'){
                    setMembers(res.data.data)
                }else{
                    alert(res.data.message); 
                }
            })
        }
    }, [show,id,user,refresh]);


    const deleteMember = (member) => {
        const stt = window.confirm('Bạn có chắc muốn xoá nhân sự khỏi bộ phận?')
        if(stt)
        Axios.delete(URL_LIST_ALL+'users_parts/'+member.idpri, user.config).then((res)=>{
            if(res.data.status==='success'){
                setRefresh(!refresh)
                
            }else{
                alert(res.data.message); 
            }
        })
    }

    const ClosePopup= () => {
        if(onRefresh)onRefresh()
        setShow(false)
    }

    return (
        <>
        {allowReset?<>
        <button className="btn btn-info btn-sm" onClick={()=>setShow(true)}><i className="fas fa-user"></i> Nhân sự</button>
        </>:<>
        <button className="btn btn-secondary btn-sm" disabled ><i className="fas fa-user"></i> Nhân sự</button>
        </>}
        <Modal show={show} onHide={() => setShow(false)} animation={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Danh sách nhân sự</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                    <div className="d-flex">
                        <span className="mr-2 mt-1">Thêm nhân sự: </span>
                        <div><UserDropDown apiname={"users?page=1&limit=500&typeaccount=1&school_id=" + school_id} placeholder="Chọn nhân sự" colvalue={'users.id'} colname={'users.fullname'}  formik={formik} name='user_id'  onChange={async(e)=>{   await formik.setFieldValue('user_id',e)   }}></UserDropDown>
                        </div>
                        <button type="submit" className="btn btn-success btn-sm mx-2" >Thêm</button>
                        <AlertErrorForm formik={formik} name="user_id"></AlertErrorForm>
                    </div>
                </form>

                {members.length>0 && <table className="table table-sm table-hover table-striped mt-2">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Họ và tên</th>
                        <th>Số điện thoại</th>
                        <th>Xoá</th>
                    </tr>
                    </thead>
                    <tbody>
                        {members.map((item,i)=><tr key={i}>
                            <td>{i+1}</td>
                            <td>{item.fullname}</td>
                            <td>{item.mobile}</td>
                            <td><button type="button" className="btn btn-danger btn-sm" onClick={()=>deleteMember(item)} >Xoá</button></td>
                        </tr>)}
                    </tbody>
                </table>}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary btn-sm" onClick={ClosePopup} >Đóng</button>
            </Modal.Footer>
        </Modal>
        </>
    );
}
